// import "@babel/polyfill";
import Vue from "vue";

//\\//\\//\\//\\//\\//\\//\\//\\
// Main
//\\//\\//\\//\\//\\//\\//\\//\\

import App from "./App.vue";
import router from "./router";
import store from "./store/index";

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-pro/css/all.min.css";

import VueResource from "vue-resource";
Vue.use(VueResource);
Vue.http.options.emulateJSON = true;

import Clipboard from "clipboard";
Vue.prototype.Clipboard = Clipboard;

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

import VueHighlightJS from "vue-highlightjs";
Vue.use(VueHighlightJS);

// var SocialSharing = require('vue-social-sharing');
import SocialSharing from "vue-social-sharing";
Vue.use(SocialSharing);

import ScrollTo from "vue-scrollto";
Vue.use(ScrollTo);

import BackToTop from "vue-backtotop";
Vue.use(BackToTop);

import Notifications from "vue-notification";
Vue.use(Notifications);

// import { VueSpinners } from "@saeris/vue-spinners";
// Vue.use(VueSpinners);

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount("#app");
